const keywords = [
  { en: "abundance and biomass", fr: "abondance et biomasse" },
  { en: "sea access", fr: "accès à la mer" },
  { en: "decision making", fr: "aide à la décision" },
  { en: "protected areas", fr: "aires protégées" },
  { en: "knowledge improvement", fr: "amélioration des connaissances" },
  { en: "land-use planning", fr: "aménagement du territoire" },
  { en: "water purification", fr: "assainissement des eaux" },
  { en: "striped bass", fr: "bar rayé" },
  { en: "watershed", fr: "bassin versant" },
  { en: "habitat characterization", fr: "caractérisation des habitats" },
  { en: "coastal characterization", fr: "caractérisation des rives" },
  { en: "climate change", fr: "changement climatique" },
  { en: "chlorophyll a", fr: "chlorophylle a" },
  { en: "resource conservation", fr: "conservation des ressources" },
  { en: "water consumption", fr: "consommation d'eau" },
  { en: "sea currents", fr: "courant marin" },
  { en: "crustacean", fr: "crustacé" },
  { en: "fresh water flow", fr: "débits eau douce" },
  { en: "water density", fr: "densité eau" },
  { en: "sustainable development", fr: "développement durable" },
  { en: "ocean-atmosphere exchange", fr: "échange océan-atmosphère" },
  { en: "sampling", fr: "échantillonnage" },
  { en: "crayfish", fr: "écrevisses" },
  { en: "mariculture", fr: "entreprises de maricultures" },
  { en: "coastal erosion", fr: "érosion des côtes" },
  { en: "endangered species", fr: "espèces en péril" },
  { en: "invasive species", fr: "espèces envahissante" },
  { en: "coastal flora", fr: "flore côtière" },
  { en: "fluorescence", fr: "fluorescence" },
  { en: "spawning", fr: "fraie" },
  { en: "community management", fr: "gestion communautaire" },
  { en: "resource management", fr: "gestion des ressources" },
  { en: "integrated management", fr: "gestion intégrée" },
  { en: "sea ice", fr: "glace de mer" },
  { en: "sensitive habitat", fr: "habitat sensible" },
  { en: "important habitat", fr: "habitats important" },
  { en: "hydrocarbon", fr: "hydrocarbure" },
  { en: "incidents", fr: "incidents" },
  { en: "general information", fr: "informations générales" },
  { en: "wildlife inventory", fr: "inventaire faunique" },
  { en: "fish inventory", fr: "inventaire poisson" },
  { en: "macroalgae", fr: "macroalgue" },
  { en: "benthic macrofauna", fr: "macrofaune benthique" },
  { en: "marine mammal", fr: "mammifères marins" },
  { en: "marsh", fr: "marais" },
  { en: "meteorology", fr: "météorologie" },
  { en: "wetlands", fr: "milieux humides" },
  { en: "natural environments of interest", fr: "milieux naturels d'intérêt" },
  { en: "enhancement", fr: "mise en valeur" },
  { en: "oceanographic missions", fr: "missions océanographique" },
  { en: "mollusc", fr: "mollusque" },
  { en: "sea level", fr: "niveau eau" },
  { en: "seabirds", fr: "oiseaux marins" },
  { en: "migrator birds", fr: "oiseaux migrateurs" },
  { en: "commercial fisheries", fr: "pêches commerciales" },
  { en: "experimental fisheries", fr: "pêches expérimentales" },
  { en: "physical-chemical", fr: "physico-chimie" },
  { en: "phytoplankton", fr: "phytoplancton" },
  { en: "sea grass", fr: "plantes aquatique" },
  { en: "fish", fr: "poisson" },
  { en: "coastal pollution", fr: "pollution côtière" },
  { en: "atmospheric pressure", fr: "pression atmosphérique" },
  { en: "coast protection", fr: "protection des côtes" },
  { en: "habitat protection", fr: "protection des habitats" },
  { en: "water quality", fr: "qualité eau" },
  { en: "radiation", fr: "radiation" },
  { en: "maritime resources", fr: "ressources maritimes" },
  { en: "ecological rehabilitation", fr: "réhabilitation écologique" },
  { en: "shore restoration", fr: "restauration des rives" },
  { en: "experimental restoration", fr: "restauration expérimentale" },
  { en: "habitat restoration", fr: "restauration habitat" },
  { en: "coastal risks", fr: "risques côtiers" },
  { en: "citizen data", fr: "saisie citoyenne" },
  { en: "salinity", fr: "salinité" },
  { en: "sediment", fr: "sédiment" },
  { en: "fishing sites", fr: "sites de pêches" },
  { en: "annual follow-up", fr: "suivi annuel" },
  { en: "species tracking", fr: "suivi des espèces" },
  { en: "habitat tracking", fr: "suivi habitat" },
  { en: "taxonomy", fr: "taxonomie" },
  { en: "remote sensing", fr: "télédétection" },
  { en: "water temperature", fr: "température de l'eau" },
  { en: "sea turtles", fr: "tortue de mer" },
  { en: "land-use", fr: "utilisation du territoire" },
  { en: "sustainabilty", fr: "utilisation durable" },
  { en: "waves", fr: "vagues" },
  { en: "wind", fr: "vents" },
  { en: "coastal zone", fr: "zone côtière" },
];
export default keywords;
